<div class="grid-x">
  <div class="cell large-12 medium-12 small-12 bold">
    <div class="section-header" [ngClass]="{ 'active' : step == activeStep }" (click)="toggleOpen()">
      <span class="margin-right">Step 8: Documentation</span>
      <button class="icon-button">
        @if (isOpen == false) {
          <svg-icon icon="icon-caret-right"></svg-icon>
        }
        @if (isOpen == true) {
          <svg-icon icon="icon-caret-down"></svg-icon>
        }
      </button>
    </div>
  </div>
</div>
<div class="grid-x margin-top" [formGroup]="form" [ngClass]="{ 'hideSection': isOpen == false }">
  <div class="cell small-12 medium-12 large-12 text-align-left">
    <span class="bold">Upload Restoration Plan (Form 4):<span [ngClass]="{ 'red': form?.get('restorationPlan')?.invalid }">*</span>:</span>
    @if (fieldHasNotes('documentation|restorationPlan') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'documentation|restorationPlan'" [notes]="getFilteredNotes('documentation|restorationPlan')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
    <br />
    <upload-view-files [uniqueId]="'restorationplan'" [allowUpload]="restorationCtrl?.enabled" [files]="restorationFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="restorationCtrl?.enabled" (fileRemoved)="restorationFileRemoved($event)" (newFilesList)="restorationFileAdded($event)"></upload-view-files>
  </div>
  <div class="cell small-12 medium-12 large-12 text-align-left">
    <span class="bold">Upload PLAT<span [ngClass]="{ 'red': form?.get('plat')?.invalid }">*</span>:</span>
    @if (fieldHasNotes('documentation|plat') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'documentation|plat'" [notes]="getFilteredNotes('documentation|plat')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
    <br />
    <upload-view-files [uniqueId]="'plat'" [allowUpload]="platCtrl?.enabled" [files]="platFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="platCtrl?.enabled" (fileRemoved)="platFileRemoved($event)" (newFilesList)="platFileAdded($event)"></upload-view-files>
  </div>
  <div class="cell small-9 medium-9 large-9 bold text-align-right padding-right">
    As determined by GIS, the provided surface location is in the following type of urban area:  (Refer to <a target="_blank" href="/law-library/view/0oQOny0s6NhC0Sti" rel="noopener noreferrer">ORC 1509.01(Y)</a>):
    @if (fieldHasNotes('documentation|urbanizedArea') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'documentation|urbanizedArea'" [notes]="getFilteredNotes('documentation|urbanizedArea')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell small-3 medium-3 large-3 text-align-left padding-left">
    <input type="text" formControlName="urbanizedArea" />
  </div>
  <div class="cell small-12 medium-12 large-12 text-align-left">
    <span class="bold">Upload Aerial Photography@if (form?.get('urbanizedArea')?.value !='NONURB') {
      <span [ngClass]="{ 'red': form?.get('aerialPhotography')?.invalid }">*</span>
    }:</span>
    @if (fieldHasNotes('documentation|aerialPhotography') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'documentation|aerialPhotography'" [notes]="getFilteredNotes('documentation|aerialPhotography')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
    <br />
    <upload-view-files [uniqueId]="'aerialPhotography'" [allowUpload]="aerialPhotographyCtrl?.enabled" [files]="aerialPhotographyFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="aerialPhotographyCtrl?.enabled" (fileRemoved)="aerialPhotographyFileRemoved($event)" (newFilesList)="aerialPhotographyFileAdded($event)"></upload-view-files>
  </div>
  <div class="cell small-12 medium-12 large-12 text-align-left">
    <span class="bold">Upload Aerial Photography with Contours@if (form?.get('urbanizedArea')?.value != 'NONURB') {
      <span [ngClass]="{ 'red': form?.get('aerialPhotographyWithContours')?.invalid }">*</span>
    }:</span>
    @if (fieldHasNotes('documentation|aerialPhotographyWithContours') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'documentation|aerialPhotographyWithContours'" [notes]="getFilteredNotes('documentation|aerialPhotographyWithContours')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
    <br />
    <upload-view-files [uniqueId]="'aerialPhotographyContours'" [allowUpload]="aerialPhotographyWithContoursCtrl?.enabled" [files]="aerialPhotographyWithContoursFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="aerialPhotographyWithContoursCtrl?.enabled" (fileRemoved)="aerialPhotographyContoursFileRemoved($event)" (newFilesList)="aerialPhotographyContoursFileAdded($event)"></upload-view-files>
  </div>
  <div class="cell small-12 medium-12 large-12 text-align-left">
    <span class="bold">Upload Urban Area Sworn Affidavit@if (form?.get('urbanizedArea')?.value != 'NONURB') {
      <span [ngClass]="{ 'red': form?.get('urbanAreaSwornStatementAffidavit')?.invalid }">*</span>
    }:</span>
    @if (fieldHasNotes('documentation|urbanAreaSwornStatementAffidavit') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'documentation|urbanAreaSwornStatementAffidavit'" [notes]="getFilteredNotes('documentation|urbanAreaSwornStatementAffidavit')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
    <br />
    <upload-view-files [uniqueId]="'urbanArea'" [allowUpload]="urbanAreaCtrl?.enabled" [files]="urbanAreaFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="urbanAreaCtrl?.enabled" (fileRemoved)="urbanAreaFileRemoved($event)" (newFilesList)="urbanAreaFileAdded($event)"></upload-view-files>
  </div>
  <div class="cell small-12 medium-12 large-12 text-align-left">
    <span class="bold">Upload Optional Miscellaneous Information:</span>
    @if (fieldHasNotes('documentation|miscellaneousDocuments') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'documentation|miscellaneousDocuments'" [notes]="getFilteredNotes('documentation|miscellaneousDocuments')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
    <br />
    <upload-view-files [uniqueId]="'miscellaneous'" [allowUpload]="miscellaneousCtrl?.enabled" [files]="miscellaneousFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="miscellaneousCtrl?.enabled" (fileRemoved)="miscellaneousFileRemoved($event)" (newFilesList)="miscellaneousFileAdded($event)"></upload-view-files>
  </div>
  <!--<div class="cell small-6 medium-3 large-3 padding-right text-align-right bold">
  Confidential Completion Reporting?
</div>
<div class="cell large-9 medium-9 small-6 padding-left text-align-left">
  <span class="padding-left">
    <input type="radio" formControlName="confidential" [value]="true" /> Yes
  </span>
  <span class="padding-right">
    <input type="radio" formControlName="confidential" [value]="false" /> No
  </span>
</div>-->
</div>